import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import {
  ServiceOrderStatusService
} from '../../../core/services/service/service-order-status/service-order-status.service'

@Component({
  selector: 'form-search-os-new',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-search-os-new.component.html',
  styleUrl: './form-search-os-new.component.scss',
})
export class FormSearchOsNewComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private serviceOrderStatusService: ServiceOrderStatusService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')
  datepickerEmission = viewChild<MatDatepicker<any>>('dateEmission')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  listStatus: any[] = []
  //   [
  //   { id: 0, description: 'Todos' },
  //   { id: 1, description: 'Aprovada' },
  //   { id: 2, description: 'Pendente' },
  //   { id: 3, description: 'Aguardando compras' },
  //   { id: 8, description: 'Devolvido Compras' },
  //   { id: 4, description: 'Análise do cliente' },
  //   { id: 5, description: 'Não aceita pelo cliente' },
  //   { id: 6, description: 'Cancelada' },
  //   { id: 7, description: 'Em aberto' },
  // ]

  ngOnInit() {
    this.getListStatus()
    this.createForm()
  }

  ngOnChanges() {
    // this.updateSearch()
  }

  getListStatus() {
    this.serviceOrderStatusService.listServiceOrderStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listStatus = response.data
        // this.listStatus.unshift({ id: 0, descricao: 'Todos' })
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  // updateSearch() {
  //   this.formSearch.get('search')?.setValue(this.search ?? '')
  // }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      codeOs: [''],
      dateStart: [''],
      dateEnd: [''],
      status: [''],
    })
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = {
        codigoOs: this.formSearch.get('codeOs')!.value ?? '',
        evento: '',
        dataInicio:  this.formSearch.get('dateStart')!.value != ''
          ? moment(this.formSearch.get('dateStart')!.value).format(
            'DD/MM/YYYY',
          )
          : '',
        dataFinal: this.formSearch.get('dateEnd')!.value != ''
          ? moment(this.formSearch.get('dateEnd')!.value).format(
            'DD/MM/YYYY',
          )
          : '',
        statusId: this.formSearch.get('status')!.value,
        codigoTg: '',
        clienteId: null,
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('codeOs')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')
      this.formSearch.get('status')!.setValue('')

      this.responseSearch.emit({
        search: true,
        model: {
          codigoOs: '',
          evento: '',
          dataInicio:  '',
          dataFinal: '',
          statusId: null,
          codigoTg: '',
          clienteId: null,
        },
      })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('codeOs')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value ||
      this.formSearch.get('status')!.value.length > 0 ||
      this.formSearch.get('status')!.value != ''
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd' | 'dateEmission') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    } else if (type == 'dateEmission') {
      this.datepickerEmission()?.open()
    }
  }
}
